import React from "react";
import {useAuth} from "../authentication/AuthContext";
import {useTask} from "./hooks/useTasks";

function getDateKey(timestamp) {
    if (!timestamp) return null;

    const date = new Date(timestamp);
    date.setHours(0, 0, 0, 0);

    return date.getTime();
}

function DashboardTask() {
    const {authToken} = useAuth();
    const {data} = useTask(authToken);

    if (!data) return null;

    const activeTasks = data.filter((task) => task.taskStatus !== 'COMPLETED');
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const todayKey = today.getTime();
    const yesterdayKey = todayKey - (24 * 60 * 60 * 1000);

    const tasksDueToday = activeTasks.filter((task) => getDateKey(task.deadlineDate) === todayKey);
    const tasksDueYesterday = activeTasks.filter((task) => getDateKey(task.deadlineDate) === yesterdayKey);
    const upcomingTasks = activeTasks
        .filter((task) => {
            const deadlineKey = getDateKey(task.deadlineDate);
            return deadlineKey !== null && deadlineKey > todayKey;
        })
        .sort((left, right) => getDateKey(left.deadlineDate) - getDateKey(right.deadlineDate));

    const visibleTasks = tasksDueToday.length > 0
        ? tasksDueToday
        : tasksDueYesterday.length > 0
            ? tasksDueYesterday
            : upcomingTasks;

    return (
        <div>
            {visibleTasks.length > 0 ? visibleTasks.slice(0, 5).map((task) => (
                <div
                    key={task.id}
                    className='group relative flex justify-between text-gray-200 mt-4 bg-gray-700 border-amber-50 border-solid py-2 px-4 rounded-xl items-center mx-[50px]'>
                    <div className='flex flex-row items-center'>
                        <span className={task.taskStatus === 'COMPLETED' ? 'line-through' : ''}>
                        {task.text}
                        </span>
                    </div>
                </div>
            )) : (
                <p className='mx-[50px] mt-6 text-sm text-gray-400'>
                    You&apos;re all caught up. Add a new task when you&apos;re ready.
                </p>
            )}
        </div>
    );
}

export default DashboardTask;